import React from 'react';

export const ModalDelivery = () => (
	<svg
		width="160"
		height="104"
		viewBox="0 0 160 104"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<g clipPath="url(#clip0_1762_21316)">
			<path d="M8 27L24 27L24 67L8 27Z" fill="#FDC300" />
			<rect
				width="40"
				height="121"
				transform="matrix(4.37114e-08 1 1 -4.37114e-08 24 27)"
				fill="#FDC300"
			/>
		</g>
		<path
			d="M34.5 74.5L126.5 74.5"
			stroke="#21282B"
			strokeWidth="3"
			strokeLinecap="round"
			strokeLinejoin="round"
		/>
		<rect x="37.5" y="21.5" width="53" height="53" rx="2.5" fill="#B8CAC4" />
		<rect
			x="37.5"
			y="21.5"
			width="53"
			height="53"
			rx="2.5"
			stroke="#21282B"
			strokeWidth="3"
			strokeLinejoin="round"
		/>
		<path
			d="M56.5 21.5H71.5V36C71.5 36.2761 71.2761 36.5 71 36.5H57C56.7239 36.5 56.5 36.2761 56.5 36V21.5Z"
			fill="white"
			stroke="#21282B"
			strokeWidth="3"
			strokeLinejoin="round"
		/>
		<path
			d="M122 74.5H123.5V73V67V63V60C123.5 57.1836 121.383 54.8617 118.654 54.5385L113.648 36.3371C113.35 35.252 112.363 34.5 111.238 34.5H92H90.5V36V73V74.5H92H122Z"
			fill="white"
			stroke="#21282B"
			strokeWidth="3"
		/>
		<path
			d="M118.5 54.5H98V42H115L118.5 54.5Z"
			fill="white"
			stroke="#21282B"
			strokeWidth="3"
			strokeLinejoin="round"
		/>
		<circle
			cx="56"
			cy="74"
			r="8.5"
			fill="white"
			stroke="#21282B"
			strokeWidth="3"
			strokeLinejoin="round"
		/>
		<circle
			cx="107"
			cy="74"
			r="8.5"
			fill="white"
			stroke="#21282B"
			strokeWidth="3"
			strokeLinejoin="round"
		/>
		<defs>
			<clipPath id="clip0_1762_21316">
				<rect
					width="40"
					height="137"
					fill="white"
					transform="matrix(4.37114e-08 1 1 -4.37114e-08 8 27)"
				/>
			</clipPath>
		</defs>
	</svg>
);
